module.exports = __webpack_public_path__ + "static/media/thunderball.b2996ab8.png";